import { THEME_TYPES } from "../../default/activities/Preview";

export const MHE_THEME_TYPES = [
    ...THEME_TYPES,
    {value: 'mhe_2023', label: 'New styles 2023'}
]
